export const actionType = [
  { value: 'remove_os', label: 'Remover as Ordens de Serviço' },
  { value: 'force_vehicle_exit', label: 'Forçar saída dos veículos' },
  { value: 'import_clients', label: 'Importação de Clientes (Excel)' }
];

export const adminActionType = [
  ...actionType,
  { value: 'change_account', label: 'Troca de Titularidade' }
];